// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8120":"9584e2a5532302e9","9857":"95639880ca5689e8"}[chunkId] + ".css";
};